import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useUpdateBankingStatementValidationMutation } from 'api/main';
import { bankingStatementStatus } from 'utils/constants';
import { texts } from 'utils/languages/fr';
import { ActionButton, Loader, ValidationText } from 'components';

const actionButtonStyle = {
    borderRadius: '5px',
    padding: '2px 5px',
    marginLeft: '20px',
};

const RIBValidationActions = ({ bankingStatement, onFinishReplace }) => {
    const [
        updateBankingStatementValidation,
        { isLoading: ribValidationLoader, isSuccess: ribValidationSuccess },
    ] = useUpdateBankingStatementValidationMutation();

    const handleUpdateBankingStatement = useCallback(
        value => () => {
            updateBankingStatementValidation({ value, id: bankingStatement?.id });
        },
        [updateBankingStatementValidation, bankingStatement]
    );

    useEffect(() => {
        if (ribValidationSuccess) {
            onFinishReplace?.();
        }
    }, [ribValidationSuccess, onFinishReplace]);

    return (
        <React.Fragment>
            {bankingStatement?.status === bankingStatementStatus.PENDING_SIGNATURE && (
                <ValidationText
                    validatedAt={bankingStatement?.validatedAt}
                    validatedBy={bankingStatement?.validatedBy}
                />
            )}
            {bankingStatement?.status === bankingStatementStatus.PENDING_VALIDATION && (
                <Loader loading={ribValidationLoader} marginTop={0} pl={2} size={20}>
                    <ActionButton
                        variant="outlined"
                        sx={actionButtonStyle}
                        onClick={handleUpdateBankingStatement(true)}
                    >
                        {texts.VALIDATE_CHANGE}
                    </ActionButton>
                    <ActionButton
                        variant="outlined"
                        sx={actionButtonStyle}
                        onClick={handleUpdateBankingStatement(false)}
                    >
                        {texts.INVALIDATE_CHANGE}
                    </ActionButton>
                </Loader>
            )}
        </React.Fragment>
    );
};

RIBValidationActions.propTypes = {
    bankingStatement: PropTypes.object,
    onFinishReplace: PropTypes.func,
};

export default RIBValidationActions;
